import LoginPage from "../../modules/login";

export default function Login() {
  return (
    <>
      <LoginPage />
    </>
  );
}
